// import React from 'react';
// import { createRoot } from 'react-dom/client';
// import { Provider } from 'react-redux';

const modules = [
  // React Modules
  // {
  //   name: 'ShopAccessories',
  //   loader: () => import('./modules/react/shop-accessories/ShopAccessoriesRoot.js'),
  //   async render(Root, el) {
  //     const store = await import('./modules/react/shop-accessories/store/index.js');
  //     createRoot(el[0]).render(<Provider store={store.store}><Root rootElement={el[0]} /></Provider>);
  //   },
  // },
  // JS Modules
  {
    name: 'Typography',
    loader: () => import('./Typography'),
    inline: false, // Set to true to bundle with app.bundle.js instead of separate chunk
  },
  {
    name: 'FormAnimation',
    loader: () => import('../../../modules/form-module/script.js'),
    inline: false,
  },
  {
    name: 'SelectC8',
    loader: () => import('../5-libs/SelectC8'),
    inline: false,
  },
  {
    name: 'Tabs',
    loader: () => import('../3-generics/Tab.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'Accordion',
    loader: () => import('../3-generics/Accordion.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'ModSlider',
    loader: () => import('../../../modules/slider/script.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'ModCarouselSlide',
    loader: () => import('../../../modules/slider-ada/script.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'BasicModule',
    loader: () => import('../../../modules/basic/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'LogoSlide',
    loader: () => import('../../../modules/logo-slide/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'TabContentTextAndImage',
    loader: () => import('../../../modules/tab-content-text-and-image/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'LocationListing',
    loader: () => import('../../../modules/location-listing/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'TabContentListing',
    loader: () => import('../../../modules/tab-content-listing/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'TestimonialsCarousel',
    loader: () => import('../../../modules/testimonials-carousel/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'ResultCarousel',
    loader: () => import('../../../modules/result-carousel/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'ContentWithNumber',
    loader: () => import('../../../modules/content-with-number/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'BrandLogo',
    loader: () => import('../../../modules/brand-logo/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'IconCards',
    loader: () => import('../../../modules/icon-cards/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'AccordionLineSeparated',
    loader: () => import('../3-generics/Accordion.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'Faqs',
    loader: () => import('../3-generics/Accordion.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'WhereForm',
    loader: () => import('../../../modules/where-form/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'UpcomingEvents',
    loader: () => import('../../../modules/upcoming-events/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'Testimonial',
    loader: () => import('../../../modules/testimonial/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'StickySubnav',
    loader: () => import('../../../modules/sticky-subnav/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'PartnerSearchFilter',
    loader: () => import('../../../modules/partner-search-filter/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'CaseStudiesFilter',
    loader: () => import('../../../modules/case-studies-filter/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'CardLarge',
    loader: () => import('../../../modules/card-large/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'CloudTransformationResources',
    loader: () => import('../../../modules/cloud-transformation-resources/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'FlipCards',
    loader: () => import('../../../modules/flip-cards/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'PartnerCaseStudies',
    loader: () => import('../../../modules/partner-case-studies/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'TeamPortraits',
    loader: () => import('../../../modules/team-portraits/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'LocationContactForm',
    loader: () => import('../../../modules/location-contact-form/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'VideoGridContent',
    loader: () => import('../../../modules/video-grid-content/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'StatProgressBars',
    loader: () => import('../../../modules/stat-progress-bars/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'StatRings',
    loader: () => import('../../../modules/stat-rings/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'CultureGallery',
    loader: () => import('../../../modules/culture-gallery/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'VideoPlayer',
    loader: () => import('../../../modules/full-width-video/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'NativeEventWhyTechx',
    loader: () => import('../../../modules/native-event-why-techx/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'NativeEventTabs',
    loader: () => import('../../../modules/native-event-tabs/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'NativeEventKeynote',
    loader: () => import('../../../modules/native-event-keynote/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'NativeEventPanelists',
    loader: () => import('../../../modules/native-event-panelists/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'NativeEventAgenda',
    loader: () => import('../../../modules/native-event-agenda/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'NativeEventFaq',
    loader: () => import('../../../modules/native-event-faq/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'NativeEventHeader',
    loader: () => import('../../../modules/native-event-header/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },
  {
    name: 'NativeEventAiCertification',
    loader: () => import('../../../modules/native-event-ai-certification/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        new ModuleClass(el).init();
      });
    },
  },

];

export default [...modules];
